import { useContext } from 'react';

import {
  AppBar,
  IconButton,
  Link,
  Switch as ThemeSwitch,
  Toolbar,
  Typography,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import SportsBarIcon from '@mui/icons-material/SportsBar';
import { SidebarContext } from 'src/context/SidebarContext';
import { ThemeContext } from 'src/context/ThemeProvider';

const AppHeader = (): JSX.Element => {
  const sidebarCtx = useContext(SidebarContext);
  const themeCtx = useContext(ThemeContext);

  const onThemeChange = () => {
    themeCtx.toggleTheme(
      themeCtx.themeName === 'darkTheme' ? 'lightTheme' : 'darkTheme'
    );
  };

  return (
    <div>
      <AppBar position='static' variant='elevation'>
        <Toolbar variant='dense'>
          <IconButton
            color='inherit'
            onClick={sidebarCtx.toggleSidebar}
            edge='start'
            sx={{ mr: 2, ...(sidebarCtx.sidebarToggle && { display: 'none' }) }}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            variant='subtitle1'
            component='div'
            sx={{ flexGrow: 1 }}
          ></Typography>
          <Link
            href='https://www.buymeacoffee.com/klohockey'
            target='_blank'
            variant='subtitle1'
            color='inherit'
            underline='none'
            sx={{ paddingRight: 2 }}
          >
            <IconButton color='inherit' edge='end'>
              <SportsBarIcon />
            </IconButton>
          </Link>
          {themeCtx.themeName === 'darkTheme' ? <DarkModeIcon /> : null}
          <ThemeSwitch size='small' onChange={onThemeChange} color='default' />
          {themeCtx.themeName !== 'darkTheme' ? <LightModeIcon /> : null}
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default AppHeader;
